import React from "react";

import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Link } from "react-router-dom";

import { Tab, Tabs, TabsContainer } from "./styled";

interface OrderTabItem {
  name: string;
  value: string;
  href?: string;
}

interface OrderTabsProps {
  tabs: OrderTabItem[];
  currentTab: number;
  onCurrentTabChange?(value: number): void;
  rightComponent?: React.ReactNode;
}

export const OrderTabs = ({
  tabs,
  currentTab,
  onCurrentTabChange,
  rightComponent,
}: OrderTabsProps) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));

  const renderTab = (tab: OrderTabItem, index: number) => {
    if (tab.href)
      return (
        <Tab
          label={tab.name}
          value={index}
          /* @ts-ignore */
          to={tab.href}
          key={tab.value}
          LinkComponent={Link}
        />
      );

    return <Tab label={tab.name} value={index} key={tab.value} />;
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    onCurrentTabChange?.(newValue);
  };

  const renderRightComponent = () => {
    if (!rightComponent) return;

    return <div>{rightComponent}</div>;
  };

  return (
    <TabsContainer>
      <Tabs
        value={currentTab}
        aria-label="nav tabs"
        role="navigation"
        onChange={handleChange}
        variant={matches ? "standard" : "fullWidth"}
      >
        {tabs.map((tab, index) => {
          return renderTab(tab, index);
        })}
      </Tabs>

      {renderRightComponent()}
    </TabsContainer>
  );
};
